import { render, staticRenderFns } from "./contentCourseLectureExamSingleChoice.vue?vue&type=template&id=6ffe28d8&"
import script from "./contentCourseLectureExamSingleChoice.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamSingleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports